<template>
  <div class="app-container dashboard-summary">
    <!-- 筛选栏 -->
    <div class="filter-container">
      <el-form :inline="true" size="small">
        <el-form-item label="订单时间">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="orderTimePickerOptions"
            clearable
            @change="handleGlobalRangeChange"
          />
          <span class="filter-hint">留空=全部历史</span>
        </el-form-item>
        <el-form-item label="下游客户">
          <el-select
            v-model="listQuery.app_client_id"
            placeholder="全部客户"
            style="width: 150px"
            clearable
            filterable
          >
            <el-option label="全部客户" :value="0" />
            <el-option
              v-for="client in appClientList"
              :key="client.id"
              :label="client.name"
              :value="client.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="上游渠道">
          <el-select
            v-model="listQuery.target_type"
            placeholder="全部渠道"
            style="width: 130px"
            clearable
            filterable
          >
            <el-option label="全部渠道" value="" />
            <el-option
              v-for="channel in channelList"
              :key="channel.value"
              :label="channel.label"
              :value="channel.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="对比">
          <el-select v-model="listQuery.compare_type" style="width: 90px">
            <el-option label="环比" value="hb" />
            <el-option label="同比" value="tb" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Hero实时概览 -->
    <div class="hero">
      <div class="hero-left">
        <span class="hero-badge">实时概览</span>
        <div class="hero-time">截至 {{ realtimeData.now }}</div>
      </div>
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日同期增长率</div>
        <div
          class="hero-rate"
          :class="realtimeData.growthRate >= 0 ? 'up' : 'down'"
        >
          {{ realtimeData.growthRate >= 0 ? '↑' : '↓' }}
          {{ Math.abs(realtimeData.growthRate) }}%
        </div>
        <div class="hero-sub">今日累计 vs 昨日同期累计</div>
      </div>
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日营业额(实时)</div>
        <div class="hero-big">¥{{ formatMoney(realtimeData.todaySales) }}</div>
        <div class="hero-sub">
          较昨日同期 {{ realtimeData.yestSameRate >= 0 ? '+' : ''
          }}{{ realtimeData.yestSameRate }}%
        </div>
      </div>
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日订单量(实时)</div>
        <div class="hero-big">{{ realtimeData.todayOrders }} 单</div>
        <div class="hero-sub">
          较昨日同期 {{ realtimeData.orderRate >= 0 ? '+' : ''
          }}{{ realtimeData.orderRate }}%
        </div>
      </div>
      <!-- <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日间夜数(实时)</div>
        <div class="hero-big">{{ realtimeData.todayNights }} 间夜</div>
        <div class="hero-sub">
          较昨日同期 {{ realtimeData.nightsRate >= 0 ? '+' : ''
          }}{{ realtimeData.nightsRate }}%
        </div>
      </div> -->
      <div class="hero-sep"></div>
      <div class="hero-block">
        <div class="hero-label">今日充值金额</div>
        <div class="hero-big" style="color: #e6a23c">
          ¥{{ formatMoney(realtimeData.todayRecharge) }}
        </div>
      </div>
    </div>

    <!-- 6 KPI卡片 -->
    <el-row :gutter="16" class="kpi-row">
      <el-col :span="4" v-for="k in kpiTop" :key="k.label">
        <el-card shadow="hover" class="kpi-card">
          <div class="kpi-label">{{ k.label }}</div>
          <div class="kpi-val" :class="k.cls">{{ k.val }}</div>
          <div class="kpi-sub">{{ k.sub }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 今日实时 vs 昨日对比表 -->
    <el-card class="mb18" shadow="never">
      <div slot="header" class="sec-title">
        今日实时 vs 昨日对比<span class="sub"
          >时间粒度计 → 截至 {{ realtimeData.now }} 的当日累计</span
        >
      </div>
      <el-table
        :data="cmpRows"
        border
        size="small"
        :header-cell-style="{
          background: '#fafafa',
          color: '#909399',
          fontWeight: 500,
        }"
      >
        <el-table-column
          prop="metric"
          label="指标"
          width="110"
        ></el-table-column>
        <el-table-column
          prop="today"
          label="今日(同时段累计)"
        ></el-table-column>
        <el-table-column prop="yest" label="昨日同时段"></el-table-column>
        <el-table-column prop="rate" label="增长率" width="110">
          <template slot-scope="scope">
            <span
              :class="getRateClass(scope.row.rate)"
              style="font-size: 13px; font-weight: 600"
              >{{ scope.row.rate }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="yfull"
          label="昨日全天"
          width="120"
        ></el-table-column>
      </el-table>
    </el-card>

    <!-- 12 KPI卡片 -->
    <el-row :gutter="16" class="kpi-row mb18">
      <el-col :span="4" v-for="k in kpiGrid" :key="k.label">
        <el-card shadow="hover" class="kpi-card">
          <div class="kpi-label">{{ k.label }}</div>
          <div class="kpi-val" :class="k.cls">{{ k.val }}</div>
          <div class="kpi-sub" v-html="k.sub"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 核心运营指标 -->
    <el-card shadow="never" class="chart-card mb18">
      <div class="chart-hd core-chart-hd">
        <div class="chart-t">
          核心运营指标
          <span v-if="coreRange === '全部' && hasGlobalRange" class="sub">
            已按所选时间范围统计
          </span>
          <span v-else-if="coreRange !== '全部'" class="sub">
            近{{ coreRange }}窗口
          </span>
        </div>
        <el-radio-group
          v-model="coreRange"
          size="small"
          @change="fetchOperationData"
        >
          <el-radio-button label="7天">7天</el-radio-button>
          <el-radio-button label="30天">30天</el-radio-button>
          <el-radio-button label="90天">90天</el-radio-button>
          <el-radio-button label="全部">全部</el-radio-button>
        </el-radio-group>
      </div>
      <div class="bottom-strip">
        <div class="bk-item">
          <div class="bk-label">平均退单率</div>
          <div
            class="bk-val"
            :class="getRateClass(operationData.refundRate, 'refund')"
          >
            {{ formatOperationValue(operationData.refundRate, '%') }}
          </div>
          <div class="bk-sub">行业良好线 &lt; 8%</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均预订成功率</div>
          <div
            class="bk-val"
            :class="getRateClass(operationData.successRate, 'success')"
          >
            {{ formatOperationValue(operationData.successRate, '%') }}
          </div>
          <div class="bk-sub">目标 ≥ 85%</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">复购率</div>
          <div
            class="bk-val"
            :class="getRateClass(operationData.repurchaseRate, 'repurchase')"
          >
            {{ formatOperationValue(operationData.repurchaseRate, '%') }}
          </div>
          <div class="bk-sub">
            较上月 {{ formatPpChange(operationData.repurchaseRateChange) }}
          </div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均入住间夜数</div>
          <div class="bk-val" style="color: #303133">
            {{ formatOperationValue(operationData.avgNights, '间夜') }}
          </div>
          <div class="bk-sub">行业标准 1.5 间夜</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均提前预订天数</div>
          <div class="bk-val" style="color: #303133">
            {{ formatOperationValue(operationData.avgLeadDays, '天') }}
          </div>
          <div class="bk-sub">反应决策周期</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">订单处理时效</div>
          <div class="bk-val" style="color: #303133">
            {{ formatOperationValue(operationData.avgHandleSeconds, '秒') }}
          </div>
          <div class="bk-sub">下单到确认耗时</div>
        </div>
      </div>
    </el-card>

    <!-- 经营趋势 -->
    <el-card class="chart-card mb18" shadow="never">
      <div class="chart-hd">
        <div class="chart-t">
          经营趋势<span class="sub">按下单时间统计</span>
        </div>
        <div style="display: flex; gap: 14px; align-items: center">
          <el-radio-group
            v-model="trendTab"
            size="small"
            @change="fetchTrendChart"
          >
            <el-radio-button label="营业额"></el-radio-button>
            <el-radio-button label="订单量"></el-radio-button>
            <el-radio-button label="客单价"></el-radio-button>
          </el-radio-group>
          <el-radio-group
            v-model="trendRange"
            size="small"
            @change="fetchTrendChart"
          >
            <el-radio-button label="近7天"></el-radio-button>
            <el-radio-button label="近30天"></el-radio-button>
            <el-radio-button label="近90天"></el-radio-button>
            <el-radio-button label="全部"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div ref="trendChart" class="echart" style="height: 320px"></div>
    </el-card>

    <!-- 3图：价格带分布、订单状态、分时下单 -->
    <el-row :gutter="12" type="flex" class="mb18 equal-chart-row">
      <el-col :span="8" class="equal-chart-col">
        <el-card class="chart-card equal-chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-hd">
            <div class="chart-t">价格带分布</div>
            <el-radio-group
              v-model="priceMetric"
              size="small"
              @change="initPriceChart"
            >
              <el-radio-button label="orders">订单量</el-radio-button>
              <el-radio-button label="revenue">营业额</el-radio-button>
            </el-radio-group>
          </div>
          <div ref="priceBandChart" class="echart" style="height: 240px"></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="equal-chart-col">
        <el-card class="chart-card equal-chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-hd">
            <div class="chart-t">订单状态分布</div>
            <el-radio-group
              v-model="statusMetric"
              size="small"
              @change="initStatusChart"
            >
              <el-radio-button label="orders">订单量</el-radio-button>
              <el-radio-button label="revenue">营业额</el-radio-button>
            </el-radio-group>
          </div>
          <div
            ref="statusDonutChart"
            class="echart"
            style="height: 240px"
          ></div>
        </el-card>
      </el-col>
      <el-col :span="8" class="equal-chart-col">
        <el-card class="chart-card equal-chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-hd">
            <div class="chart-t">
              <span class="desktop-chart-title">分时下单统计</span>
              <span class="mobile-chart-title">{{ hourlyChartTitle }}</span>
              <span v-if="hourlyDay === 'history'" class="sub">
                {{ hasGlobalRange ? '已按所选时间范围聚合' : '全部历史按小时聚合' }}
              </span>
            </div>
            <div class="chart-controls chart-controls--hourly">
              <el-radio-group
                v-model="hourlyDay"
                size="mini"
                @change="handleHourlyDayChange"
              >
                <el-radio-button label="today">今天</el-radio-button>
                <el-radio-button label="yesterday">昨天</el-radio-button>
                <el-radio-button label="history">历史</el-radio-button>
              </el-radio-group>
              <el-radio-group
                v-model="hourlyMetric"
                size="mini"
                @change="initHourlyChart"
              >
                <el-radio-button label="orders">单量</el-radio-button>
                <el-radio-button label="revenue">金额</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div ref="hourlyBarChart" class="echart" style="height: 240px"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 2图：城市TOP10、客户贡献度 -->
    <el-row :gutter="12" class="mb18">
      <el-col :span="14">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-hd">
            <div class="chart-t">目的地城市 TOP10</div>
            <el-radio-group
              v-model="cityTab"
              size="small"
              @change="fetchCityChart"
            >
              <el-radio-button label="订单量"></el-radio-button>
              <el-radio-button label="营业额"></el-radio-button>
            </el-radio-group>
          </div>
          <div ref="cityBarChart" class="echart" style="height: 260px"></div>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card class="chart-card" shadow="never" body-style="padding: 18px;">
          <div class="chart-t" style="margin-bottom: 10px">
            客户贡献度<span class="sub">帕累托分析</span>
          </div>
          <div ref="paretoChart" class="echart" style="height: 260px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import * as echarts from 'echarts'
import moment from 'moment'
import { fetchTargetTypes } from '@/utils/targetType'
import {
  buildComparisonAverages,
  buildPriceBands,
  formatChartMetric,
  formatPriceBandLabel,
  getDimensionPieSeries,
  getHourlyChartSeries,
  getHourlyChartTitle,
  getPriceBandValues,
} from '@/utils/dashboardPresentation'

export default {
  name: 'DashboardSummary',
  data() {
    return {
      listQuery: {
        app_client_id: 0,
        target_type: '',
        compare_type: 'hb',
        start_at: '',
        end_at: '',
      },
      dateArr: null,
      orderTimePickerOptions: {
        shortcuts: [
          {
            text: '近7天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 6)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近30天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 29)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近90天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 89)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      appClientList: [],
      channelList: [],

      realtimeData: {
        now: '',
        todaySales: 0,
        todayOrders: 0,
        todayNights: 0,
        yestRecharge: 0,
        todayRecharge: 0,
        growthRate: 0,
        yestSameRate: 0,
        orderRate: 0,
        nightsRate: 0,
      },

      kpiTop: [],
      kpiGrid: [],
      cmpRows: [],

      operationData: {
        refundRate: null,
        successRate: null,
        repurchaseRate: null,
        repurchaseRateChange: null,
        avgNights: null,
        avgLeadDays: null,
        avgHandleSeconds: null,
      },

      trendTab: '营业额',
      trendRange: '全部',
      coreRange: '全部',
      cityTab: '订单量',
      priceMetric: 'orders',
      statusMetric: 'orders',
      hourlyDay: 'today',
      hourlyMetric: 'orders',
      hourlyHistoryData: {
        orders: Array(24).fill(0),
        revenue: Array(24).fill(0),
      },

      refreshTimer: null,
      trendChartInstance: null,
      priceBandChartInstance: null,
      statusChartInstance: null,
      hourlyChartInstance: null,
      cityChartInstance: null,
      paretoChartInstance: null,
      chartResizeHandler: null,
      requestVersion: 0,
      operationRequestVersion: 0,
      hourlyHistoryRequestVersion: 0,

      // 缓存维度数据，避免重复请求
      cachedDimensions: {
        status: [],
        hourly: [],
        city: [],
      },
      priceBands: buildPriceBands([]),
    }
  },
  computed: {
    hasGlobalRange() {
      return Boolean(this.listQuery.start_at && this.listQuery.end_at)
    },
    hourlyChartTitle() {
      return getHourlyChartTitle(this.hourlyDay, this.hourlyMetric)
    },
  },
  created() {
    this.getAppClientList()
    this.getChannelList()
    this.startAutoRefresh()
    this.$nextTick(() => {
      this.fetchAllData()
    })
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
    this.destroyCharts()
  },
  methods: {
    async fetchAllData() {
      const version = ++this.requestVersion
      const params = this.getQueryParams()
      const fixedParams = this.getFixedQueryParams()
      const coreRange = this.coreRange
      const hourlyDay = this.hourlyDay

      const [
        realtimeRes,
        indexRes,
        yesterdayRes,
        dimensionsRes,
        hotelListRes,
        trendRes,
        contributionRes,
        fixedIndexRes,
        operationRes,
        hourlyHistoryRes,
      ] = await Promise.all([
        this.requestSafe({
          url: '/api/backend/dataCount/realtime',
          method: 'get',
          params: fixedParams,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/index',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/yesterday',
          method: 'get',
          params: fixedParams,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/dimensions',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/hotelList',
          method: 'get',
          params,
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/salasChart',
          method: 'get',
          params: this.getTrendParams(),
        }),
        this.requestSafe({
          url: '/api/backend/dataCount/contribution',
          method: 'get',
          params: this.getQueryParams({ top_n: 10 }),
        }),
        this.hasGlobalRange
          ? this.requestSafe({
              url: '/api/backend/dataCount/index',
              method: 'get',
              params: fixedParams,
            })
          : Promise.resolve(null),
        coreRange === '全部'
          ? Promise.resolve(null)
          : this.requestSafe({
              url: '/api/backend/dataCount/index',
              method: 'get',
              params: this.getCoreParams(coreRange),
            }),
        hourlyDay === 'history'
          ? this.requestSafe({
              url: '/api/backend/dataCount/salasChart',
              method: 'get',
              params: this.getHourlyHistoryParams(),
            })
          : Promise.resolve(null),
      ])

      if (version !== this.requestVersion) return

      const realtimeData = realtimeRes?.data
      const indexData = indexRes?.data
      const fixedIndexData = fixedIndexRes?.data || indexData
      const yesterdayData = yesterdayRes?.data

      if (realtimeData) {
        this.applyRealtimeData(realtimeData)
      }
      if (indexData || yesterdayData || realtimeData) {
        this.applyKpiData(
          indexData || {},
          yesterdayData || {},
          realtimeData || {},
          fixedIndexData || {},
        )
      }
      if (realtimeData || yesterdayData) {
        this.applyComparison(realtimeData || {}, yesterdayData || {})
      }
      const operationData =
        coreRange === '全部' ? indexData : operationRes?.data
      if (coreRange === this.coreRange && operationData) {
        this.applyOperationData(operationData)
      }
      this.applyDimensionsData(dimensionsRes?.data || {})
      this.applyPriceBandData(hotelListRes?.data || [])
      if (hourlyDay === 'history' && hourlyDay === this.hourlyDay) {
        this.applyHourlyHistoryData(hourlyHistoryRes?.data || {})
      }
      if (trendRes?.data) {
        this.initTrendChart(trendRes.data)
      }

      const contributionData = contributionRes?.data || {}
      this.initParetoChart(
        contributionData.clients || [],
        contributionData.total || 0,
      )
    },

    getQueryParams(extra = {}) {
      return {
        ...this.listQuery,
        app_client_id: this.listQuery.app_client_id || 0,
        ...extra,
      }
    },

    getFixedQueryParams(extra = {}) {
      return {
        app_client_id: this.listQuery.app_client_id || 0,
        target_type: this.listQuery.target_type || '',
        compare_type: this.listQuery.compare_type,
        ...extra,
      }
    },

    requestSafe(config) {
      return request(config).catch(() => null)
    },

    getRangeParams(range, includeNearPrefix = true) {
      const rangeMap = includeNearPrefix
        ? { 近7天: 7, 近30天: 30, 近90天: 90 }
        : { '7天': 7, '30天': 30, '90天': 90 }
      const days = rangeMap[range]
      if (!days) return this.getQueryParams()

      return {
        ...this.getFixedQueryParams(),
        start_at: moment()
          .subtract(days - 1, 'days')
          .format('YYYY-MM-DD 00:00:00'),
        end_at: moment().format('YYYY-MM-DD 23:59:59'),
      }
    },

    getCoreParams(range = this.coreRange) {
      return this.getRangeParams(range, false)
    },

    getTrendParams() {
      return {
        ...this.getRangeParams(this.trendRange),
        type: 'day',
      }
    },

    getHourlyHistoryParams() {
      return {
        ...this.getQueryParams(),
        type: 'hour',
      }
    },

    fetchRealtime() {
      return this.requestSafe({
        url: '/api/backend/dataCount/realtime',
        method: 'get',
        params: this.getFixedQueryParams(),
      }).then((response) => {
        if (response?.data) {
          this.applyRealtimeData(response.data)
        }
      })
    },

    applyRealtimeData(data) {
      this.realtimeData = {
        now: data.now || moment().format('YYYY-MM-DD HH:mm:ss'),
        todaySales: data.today?.sales_cum || 0,
        todayOrders: data.today?.order_cum || 0,
        todayNights: data.today?.room_nights_cum || 0,
        yestRecharge: data.recharge?.yesterday || 0,
        todayRecharge: data.recharge?.today || 0,
        growthRate: this.calcGrowthRate(
          data.today?.sales_cum,
          data.yesterday_same_period?.sales_cum,
        ),
        yestSameRate: this.calcGrowthRate(
          data.today?.sales_cum,
          data.yesterday_same_period?.sales_cum,
        ),
        orderRate: this.calcGrowthRate(
          data.today?.order_cum,
          data.yesterday_same_period?.order_cum,
        ),
        nightsRate: this.calcGrowthRate(
          data.today?.room_nights_cum,
          data.yesterday_same_period?.room_nights_cum,
        ),
      }
    },

    applyKpiData(data, yest, realtime, fixedData) {
      const yesterdayRecharge =
        realtime.recharge?.yesterday ?? fixedData.yesterday_recharge ?? 0
      const yesterdaySales =
        parseFloat(yest.sales || fixedData.yesterday_sales || 0) || 0
      const yesterdayRoomNights = parseFloat(yest.room_nights || 0) || 0
      const yesterdayOrderNum =
        parseInt(yest.order_num || fixedData.yesterday_order_num || 0, 10) || 0
      const yesterdayAvgNightPrice = yesterdayRoomNights
        ? yesterdaySales / yesterdayRoomNights
        : 0
      const yesterdayCustomerPrice = yesterdayOrderNum
        ? yesterdaySales / yesterdayOrderNum
        : 0
      const totalRoomNights = parseInt(data.total_room_nights || 0, 10) || 0
      const totalOrderNum = parseInt(data.total_order_num || 0, 10) || 0
      const avgRoomNightsPerOrder = totalOrderNum
        ? totalRoomNights / totalOrderNum
        : 0
      this.kpiTop = [
        {
          label: '昨日营业额',
          val:
            '¥' + this.formatMoney(yest.sales || fixedData.yesterday_sales || 0),
          cls: 'blue',
          sub: '全天合计',
        },
        {
          label: '昨日订单量',
          val:
            (yest.order_num || fixedData.yesterday_order_num || 0) + ' 单',
          cls: 'dark',
          sub: '客单价 ¥' + (yest.adr || 0),
        },
        {
          label: '昨日间夜数',
          val: (yest.room_nights || 0) + ' 间夜',
          cls: 'dark',
          sub: '平均 ¥' + yesterdayAvgNightPrice.toFixed(2) + ' 间夜',
        },
        {
          label: '昨日充值金额',
          val: '¥' + this.formatMoney(yesterdayRecharge),
          cls: 'orange',
        },
        {
          label: '昨日退单率',
          val: (yest.refund_rate || 0) + '%',
          cls: 'red',
          sub: '行业良好线 < 8%',
        },
        {
          label: '昨日预订成功率',
          val: (yest.booking_success_rate || 0) + '%',
          cls: 'green',
          sub: '复购率 ' + (yest.repurchase_rate || 0) + '%',
        },
      ]
      this.kpiGrid = [
        {
          label: '累计营业额 ⓘ',
          val: '¥' + this.formatMoney(data.total_sales || 0),
          cls: 'blue',
          sub: '全量累计',
        },
        {
          label: '今日营业额',
          val: '¥' + this.formatMoney(fixedData.today_sales || 0),
          cls: 'blue',
          sub:
            '<span style="color:#67C23A;">' +
            (fixedData.today_sales_yesterday_compare_ratio || 0) +
            '% 较昨日</span>',
        },
        {
          label: '累计订单量',
          val: this.formatNumber(totalOrderNum),
          cls: 'dark',
          sub:
            '近30天 ' +
            this.formatNumber(fixedData.last_30_days_order_num || 0) +
            ' 单',
        },
        {
          label: '今日订单量',
          val: (fixedData.today_order_num || 0) + ' 单',
          cls: 'dark',
          sub:
            '<span style="color:#67C23A;">' +
            (fixedData.today_orders_yesterday_compare_ratio || 0) +
            '% 较昨日</span>',
        },
        {
          label: '累计间夜数 ⓘ',
          val: this.formatNumber(totalRoomNights) + ' 间夜',
          cls: 'dark',
          sub: '平均 ' + avgRoomNightsPerOrder.toFixed(2) + ' 间夜/单',
        },
        {
          label: '下游客户数 ⓘ',
          val: (fixedData.account_count || 0) + ' 家',
          cls: 'dark',
          sub: '活跃 ' + (fixedData.active_clients || 0) + ' 家',
        },
        {
          label: '今日客单价 ⓘ',
          val: '¥' + this.formatMoney(fixedData.today_adr || 0),
          cls: 'dark',
          sub: '昨日 ¥' + this.formatMoney(yesterdayCustomerPrice),
        },
        {
          label: '今日平均房价 ADR ⓘ',
          val: '¥' + this.formatMoney(fixedData.today_adr_per_night || 0),
          cls: 'dark',
          sub: '按间夜口径（≠客单价）',
        },
        {
          label: '今日充值',
          val: '¥' + this.formatMoney(fixedData.today_recharge || 0),
          cls: 'orange',
          sub: '实时到账',
        },
        {
          label: '昨日充值',
          val: '¥' + this.formatMoney(yesterdayRecharge),
          cls: 'orange',
          sub: '',
        },
        {
          label: '近30天充值',
          val: '¥' + this.formatMoney(fixedData.last_30_days_recharge || 0),
          cls: 'orange',
          sub:
            '日均 ¥' + this.formatMoney(fixedData.avg_daily_recharge || 0),
        },
        {
          label: '历史充值总额',
          val: '¥' + this.formatMoney(fixedData.historical_recharge || 0),
          cls: 'orange',
          sub: '全部账户共' + (fixedData.account_count || 0) + '个',
        },
      ]
    },

    applyComparison(realtimeData, yesterdayData) {
      const today = realtimeData.today || {}
      const yestSame = realtimeData.yesterday_same_period || {}
      const yestFull = yesterdayData || {}
      const averages = buildComparisonAverages(realtimeData, yesterdayData)
      const formatAverage = (value) =>
        value === null ? '—' : '¥' + value.toFixed(2)
      const formatAverageRate = (current, previous) =>
        current === null || previous === null
          ? '—'
          : this.calcRateStr(current, previous)
      this.cmpRows = [
        {
          metric: '资金额',
          today: '¥' + this.formatMoney(today.sales_cum || 0),
          yest: '¥' + this.formatMoney(yestSame.sales_cum || 0),
          rate: this.calcRateStr(today.sales_cum, yestSame.sales_cum),
          yfull: '¥' + this.formatMoney(yestFull.sales || 0),
        },
        {
          metric: '订单量',
          today: (today.order_cum || 0) + ' 单',
          yest: (yestSame.order_cum || 0) + ' 单',
          rate: this.calcRateStr(today.order_cum, yestSame.order_cum),
          yfull: (yestFull.order_num || 0) + ' 单',
        },
        {
          metric: '间夜数',
          today: (today.room_nights_cum || 0) + ' 间夜',
          yest: (yestSame.room_nights_cum || 0) + ' 间夜',
          rate: this.calcRateStr(
            today.room_nights_cum,
            yestSame.room_nights_cum,
          ),
          yfull: (yestFull.room_nights || 0) + ' 间夜',
        },
        {
          metric: '客单价',
          today: formatAverage(averages.customerPrice.today),
          yest: formatAverage(averages.customerPrice.yesterdaySamePeriod),
          rate: formatAverageRate(
            averages.customerPrice.today,
            averages.customerPrice.yesterdaySamePeriod,
          ),
          yfull: formatAverage(averages.customerPrice.yesterdayFull),
        },
        {
          metric: '平均房价 ADR',
          today: formatAverage(averages.adr.today),
          yest: formatAverage(averages.adr.yesterdaySamePeriod),
          rate: formatAverageRate(
            averages.adr.today,
            averages.adr.yesterdaySamePeriod,
          ),
          yfull: formatAverage(averages.adr.yesterdayFull),
        },
        {
          metric: '充值金额',
          today: '¥' + this.formatMoney(realtimeData.recharge?.today || 0),
          yest: '—',
          rate: '—',
          yfull: '¥' + this.formatMoney(realtimeData.recharge?.yesterday || 0),
        },
      ]
    },

    applyOperationData(data) {
      this.operationData = {
        refundRate: data.avg_refund_rate ?? null,
        successRate: data.avg_booking_success_rate ?? null,
        repurchaseRate: data.repurchase_rate ?? null,
        repurchaseRateChange: data.repurchase_rate_change ?? null,
        avgNights: data.avg_nights ?? null,
        avgLeadDays: data.avg_lead_days ?? null,
        avgHandleSeconds: data.avg_handle_seconds ?? null,
      }
    },

    getAppClientList() {
      request({
        url: '/api/backend/dataCount/appClientList',
        method: 'get',
        params: { limit: 500, quick_filter: 'all' },
      }).then((response) => {
        const payload = response.data || []
        this.appClientList = Array.isArray(payload)
          ? payload
          : payload.data || []
      })
    },

    getChannelList() {
      fetchTargetTypes().then((types) => {
        this.channelList = (types || []).map((item) => ({
          label: item.label || item.name || item.value,
          value: item.value || item.id,
        }))
      })
    },

    fetchTrendChart() {
      return this.requestSafe({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: this.getTrendParams(),
      }).then((response) => {
        if (response?.data) {
          this.initTrendChart(response.data)
        }
      })
    },

    fetchOperationData() {
      const version = ++this.operationRequestVersion
      const range = this.coreRange
      return this.requestSafe({
        url: '/api/backend/dataCount/index',
        method: 'get',
        params: this.getCoreParams(range),
      }).then((response) => {
        if (
          version === this.operationRequestVersion &&
          range === this.coreRange &&
          response?.data
        ) {
          this.applyOperationData(response.data)
        }
      })
    },

    handleHourlyDayChange() {
      if (this.hourlyDay === 'history') {
        return this.fetchHourlyHistoryChart()
      }
      this.initHourlyChart()
      return Promise.resolve()
    },

    fetchHourlyHistoryChart() {
      const version = ++this.hourlyHistoryRequestVersion
      return this.requestSafe({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: this.getHourlyHistoryParams(),
      }).then((response) => {
        if (
          version === this.hourlyHistoryRequestVersion &&
          this.hourlyDay === 'history'
        ) {
          this.applyHourlyHistoryData(response?.data || {})
        }
      })
    },

    fetchCityChart() {
      // 使用缓存的数据重新渲染城市图表
      if (this.cachedDimensions.city?.length) {
        this.initCityChart(this.cachedDimensions.city)
      } else {
        this.initCityChart([])
      }
    },

    // 一次性获取所有维度数据，避免重复调用 API
    fetchDimensions() {
      request({
        url: '/api/backend/dataCount/dimensions',
        method: 'get',
        params: this.getQueryParams(),
      })
        .then((response) => {
          this.applyDimensionsData(response.data || {})
        })
        .catch(() => {
          this.applyDimensionsData({})
        })
    },

    applyDimensionsData(data) {
      this.cachedDimensions = data && typeof data === 'object' ? data : {}
      this.initStatusChart()
      this.initHourlyChart()
      this.initCityChart(data.city || [])
    },

    applyPriceBandData(hotels) {
      this.priceBands = buildPriceBands(hotels)
      this.initPriceChart()
    },

    applyHourlyHistoryData(data) {
      this.hourlyHistoryData = {
        orders: this.normalizeHourlyValues(
          data.order_num_chart_list || data.hourly || [],
        ),
        revenue: this.normalizeHourlyValues(
          data.salas_chart_list || data.hourly_sales || [],
        ),
      }
      this.initHourlyChart()
    },

    normalizeHourlyValues(values) {
      const source = Array.isArray(values) ? values : []
      return Array.from(
        { length: 24 },
        (_, index) => parseFloat(source[index]) || 0,
      )
    },

    fetchParetoChart() {
      if (!this.$refs.paretoChart) return
      this.requestSafe({
        url: '/api/backend/dataCount/contribution',
        method: 'get',
        params: this.getQueryParams({ top_n: 10 }),
      }).then((response) => {
        if (!response?.data) {
          this.initParetoChart([], 0)
          return
        }
        const data = response.data || {}
        const clients = data.clients || []
        this.initParetoChart(clients, data.total)
      })
    },

    initTrendChart(data) {
      if (!this.$refs.trendChart) return
      if (!this.trendChartInstance) {
        this.trendChartInstance = echarts.init(this.$refs.trendChart)
      }
      const dates = data.dates || []
      const sales = (data.salas_chart_list || []).map((v) => parseFloat(v) || 0)
      const orders = (data.order_num_chart_list || []).map(
        (v) => parseFloat(v) || 0,
      )
      const rev =
        this.trendTab === '订单量'
          ? orders
          : this.trendTab === '客单价'
          ? sales.map((v, index) =>
              orders[index] ? Number((v / orders[index]).toFixed(2)) : 0,
            )
          : sales
      const avg = this.calcMovingAverage(rev, 7)

      // 系列名称
      const seriesName = this.trendTab
      const yAxisName = this.trendTab === '客单价' ? '金额' : this.trendTab

      this.trendChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        legend: {
          data: [seriesName, '7日移动平均'],
          top: 0,
          right: 10,
          textStyle: { fontSize: 12 },
        },
        grid: { left: 55, right: 55, top: 45, bottom: 30 },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: { fontSize: 10, color: '#909399' },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisTick: { show: false },
        },
        yAxis: {
          type: 'value',
          name: yAxisName,
          axisLabel: { fontSize: 10, color: '#909399' },
          splitLine: { lineStyle: { color: '#f0f2f5' } },
        },
        series: [
          {
            name: seriesName,
            type: 'line',
            data: rev,
            smooth: true,
            lineStyle: { color: '#409EFF', width: 2.5 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(64,158,255,0.18)' },
                { offset: 1, color: 'rgba(64,158,255,0.01)' },
              ]),
            },
            itemStyle: { color: '#409EFF' },
            symbol: 'circle',
            symbolSize: 6,
            markPoint: {
              symbol: 'pin',
              symbolSize: 48,
              data: [
                { type: 'max', name: '峰值' },
                { type: 'min', name: '低值' },
              ],
              label: { fontSize: 10, color: '#fff', fontWeight: 600 },
              itemStyle: { color: '#409EFF' },
            },
          },
          {
            name: '7日移动平均',
            type: 'line',
            data: avg,
            smooth: true,
            lineStyle: { color: '#E6A23C', width: 1.5, type: 'dashed' },
            itemStyle: { color: '#E6A23C' },
            symbol: 'none',
          },
        ],
      })
      this.ensureChartResize()
    },

    initPriceChart() {
      if (!this.$refs.priceBandChart) return
      if (!this.priceBandChartInstance) {
        this.priceBandChartInstance = echarts.init(this.$refs.priceBandChart)
      }
      const metric = this.priceMetric
      const isRevenue = metric === 'revenue'
      const bands = this.priceBands
      const values = getPriceBandValues(bands, metric)
      const total = values.reduce((sum, value) => sum + value, 0)
      const colors = ['#B3D8F7', '#409EFF', '#1F6FD6', '#123C7A']

      this.priceBandChartInstance.setOption({
        grid: { left: 10, right: 16, top: 26, bottom: 4, containLabel: true },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            const point = params[0]
            const band = bands[point.dataIndex]
            const percent =
              total > 0 ? ((point.value / total) * 100).toFixed(1) : '0.0'
            return `${point.name} · ${band.hotel_cnt} 家<br>${formatChartMetric(
              point.value,
              metric,
            )}（占 ${percent}%）`
          },
        },
        xAxis: {
          type: 'category',
          data: bands.map((band) => band.name),
          axisLine: { lineStyle: { color: '#dcdfe6' } },
          axisTick: { show: false },
          axisLabel: { color: '#606266', fontSize: 11 },
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { color: '#f0f2f5' } },
          axisLabel: {
            color: '#909399',
            formatter: (value) => (isRevenue ? `${value / 10000}万` : value),
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: '46%',
            data: values.map((value, index) => ({
              value,
              itemStyle: { color: colors[index] },
            })),
            label: {
              show: true,
              position: 'top',
              fontSize: 11,
              color: '#303133',
              formatter: ({ value }) => formatPriceBandLabel(value, metric),
            },
          },
        ],
      }, true)
      this.ensureChartResize()
    },

    initStatusChart() {
      if (!this.$refs.statusDonutChart) return
      if (!this.statusChartInstance) {
        this.statusChartInstance = echarts.init(this.$refs.statusDonutChart)
      }
      const metric = this.statusMetric
      const chartData = getDimensionPieSeries(
        this.cachedDimensions,
        'status',
        metric,
      )
      this.statusChartInstance.setOption({
        tooltip: {
          trigger: 'item',
          formatter: (params) =>
            `${params.name}: ${formatChartMetric(
              params.value,
              metric,
            )} (${params.percent}%)`,
        },
        series: [
          {
            type: 'pie',
            radius: ['48%', '73%'],
            center: ['50%', '55%'],
            label: {
              formatter: (params) =>
                `${params.name}\n${formatChartMetric(params.value, metric)}`,
              fontSize: 10,
              color: '#606266',
            },
            data: chartData,
          },
        ],
      }, true)
      this.ensureChartResize()
    },

    initHourlyChart() {
      if (!this.$refs.hourlyBarChart) return
      if (!this.hourlyChartInstance) {
        this.hourlyChartInstance = echarts.init(this.$refs.hourlyBarChart)
      }
      const metric = this.hourlyMetric
      const hourlyData = getHourlyChartSeries(
        this.cachedDimensions,
        this.hourlyHistoryData,
        this.hourlyDay,
        metric,
      )
      const average = Number(
        (
          hourlyData.reduce((total, value) => total + value, 0) /
          hourlyData.length
        ).toFixed(1),
      )
      const series = {
        type: 'bar',
        data: hourlyData,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#2b6cb0' },
            { offset: 1, color: '#5a9fd9' },
          ]),
          borderRadius: [4, 4, 0, 0],
        },
        barWidth: '55%',
      }
      if (metric === 'orders') {
        series.markLine = {
          silent: true,
          data: [
            {
              yAxis: average,
              label: { formatter: `→avg ${average}`, fontSize: 10 },
              lineStyle: { color: '#E6A23C', type: 'dashed' },
            },
          ],
        }
      }
      this.hourlyChartInstance.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const point = params[0]
            return `${point.name}<br>${formatChartMetric(point.value, metric)}`
          },
        },
        grid: { left: 45, right: 15, top: 20, bottom: 30 },
        xAxis: {
          type: 'category',
          data: this.getHourLabels(),
          axisLabel: { fontSize: 9, color: '#909399', interval: 2 },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisTick: { show: false },
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { color: '#f0f2f5' } },
          axisLabel: {
            fontSize: 10,
            color: '#909399',
            formatter: (value) =>
              metric === 'revenue' && value >= 1000
                ? `${(value / 1000).toFixed(1)}k`
                : value,
          },
        },
        series: [series],
      }, true)
      this.ensureChartResize()
    },

    initCityChart(cityData) {
      if (!this.$refs.cityBarChart) return
      if (!this.cityChartInstance) {
        this.cityChartInstance = echarts.init(this.$refs.cityBarChart)
      }
      const isOrder = this.cityTab === '订单量'
      const cities = (cityData || []).map((d) => d.name)
      const vals = (cityData || []).map((d) => (isOrder ? d.orders : d.sales))

      this.cityChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 60, right: 30, top: 10, bottom: 20 },
        xAxis: {
          type: 'value',
          splitLine: { lineStyle: { color: '#f0f2f5' } },
          axisLabel: { fontSize: 10, color: '#909399' },
        },
        yAxis: {
          type: 'category',
          data: cities,
          inverse: true,
          axisLabel: { fontSize: 11, color: '#303133' },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
        },
        series: [
          {
            type: 'bar',
            data: vals,
            itemStyle: { color: '#66B2FF', borderRadius: [0, 3, 3, 0] },
            barWidth: '55%',
            label: {
              show: true,
              position: 'right',
              fontSize: 10,
              color: '#303133',
            },
          },
        ],
      })
      this.ensureChartResize()
    },

    initParetoChart(clientData, totalAmount) {
      if (!this.$refs.paretoChart) return
      if (!this.paretoChartInstance) {
        this.paretoChartInstance = echarts.init(this.$refs.paretoChart)
      }
      // 处理客户端贡献度数据
      const data = clientData || []
      const names = data.map((d) => d.name)
      // 贡献额从元转换为万元
      const bars = data.map(
        (d) => Math.round((d.contribution_yuan / 10000) * 100) / 100,
      )
      let sum = 0
      const total =
        (parseFloat(totalAmount) || 0) > 0
          ? parseFloat(totalAmount) / 10000
          : bars.reduce((a, b) => a + b, 0) || 1
      const line = bars.map((v) => {
        sum += v
        return Math.round((sum / total) * 100)
      })

      this.paretoChartInstance.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
        },
        legend: {
          data: ['贡献额(万)', '累计占比'],
          top: 0,
          right: 10,
          textStyle: { fontSize: 11 },
        },
        grid: { left: 50, right: 50, top: 40, bottom: 50 },
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: { fontSize: 9, color: '#909399', rotate: 30, interval: 0 },
          axisLine: { lineStyle: { color: '#e4e7ed' } },
          axisTick: { show: false },
        },
        yAxis: [
          {
            type: 'value',
            name: '金额',
            splitLine: { lineStyle: { color: '#f0f2f5' } },
            axisLabel: { fontSize: 10, color: '#909399' },
          },
          {
            type: 'value',
            name: '占比 %',
            min: 0,
            max: 100,
            axisLabel: {
              formatter: '{value}%',
              fontSize: 10,
              color: '#909399',
            },
            splitLine: { show: false },
          },
        ],
        series: [
          {
            name: '贡献额(万)',
            type: 'bar',
            data: bars,
            itemStyle: { color: '#90CAF9', borderRadius: [2, 2, 0, 0] },
            barWidth: '45%',
          },
          {
            name: '累计占比',
            type: 'line',
            yAxisIndex: 1,
            data: line,
            smooth: true,
            lineStyle: { color: '#F56C6C', width: 2 },
            itemStyle: { color: '#F56C6C' },
            symbol: 'circle',
            symbolSize: 5,
          },
        ],
      })
      this.ensureChartResize()
    },

    destroyCharts() {
      if (this.chartResizeHandler) {
        window.removeEventListener('resize', this.chartResizeHandler)
        this.chartResizeHandler = null
      }
      this.trendChartInstance?.dispose()
      this.priceBandChartInstance?.dispose()
      this.statusChartInstance?.dispose()
      this.hourlyChartInstance?.dispose()
      this.cityChartInstance?.dispose()
      this.paretoChartInstance?.dispose()
    },

    ensureChartResize() {
      if (this.chartResizeHandler) return
      this.chartResizeHandler = () => {
        this.trendChartInstance?.resize()
        this.priceBandChartInstance?.resize()
        this.statusChartInstance?.resize()
        this.hourlyChartInstance?.resize()
        this.cityChartInstance?.resize()
        this.paretoChartInstance?.resize()
      }
      window.addEventListener('resize', this.chartResizeHandler)
    },

    getRateClass(val, kind) {
      if (val === null || val === undefined || val === '' || val === '—') {
        return ''
      }
      const v = parseFloat(val) || 0
      if (kind === 'refund') {
        if (v <= 8) return 'rate-green'
        if (v <= 15) return 'rate-orange'
        return 'rate-red'
      }
      if (kind === 'success') {
        if (v >= 95) return 'rate-green'
        if (v >= 85) return 'rate-orange'
        return 'rate-red'
      }
      if (kind === 'repurchase') {
        if (v >= 15) return 'rate-green'
        if (v >= 5) return 'rate-orange'
        return 'rate-red'
      }
      if (typeof val === 'string') {
        return val.indexOf('↑') >= 0
          ? 'hero-rate up'
          : val.indexOf('↓') >= 0
          ? 'hero-rate down'
          : ''
      }
      return v >= 0 ? 'hero-rate up' : 'hero-rate down'
    },

    calcGrowthRate(curr, prev) {
      const c = parseFloat(curr) || 0
      const p = parseFloat(prev) || 0
      if (!p || p === 0) return 0
      return (((c - p) / p) * 100).toFixed(1)
    },

    calcRateStr(curr, prev) {
      const c = parseFloat(curr) || 0
      const p = parseFloat(prev) || 0
      if (!p || p === 0) return '—'
      const rate = (((c - p) / p) * 100).toFixed(1)
      return rate >= 0 ? '↑' + rate + '%' : '↓' + Math.abs(rate) + '%'
    },

    calcMovingAverage(list, size = 7) {
      return (list || []).map((_, index) => {
        const start = Math.max(0, index - size + 1)
        const segment = list.slice(start, index + 1)
        const total = segment.reduce(
          (sum, val) => sum + (parseFloat(val) || 0),
          0,
        )
        return segment.length ? Number((total / segment.length).toFixed(2)) : 0
      })
    },

    formatPpChange(val) {
      if (val === null || val === undefined || val === '' || val === '—') {
        return '—'
      }
      const num = parseFloat(val)
      if (!Number.isFinite(num)) return '—'
      return (num > 0 ? '+' : '') + num + 'pp'
    },

    formatOperationValue(val, unit) {
      if (val === null || val === undefined || val === '' || val === '—') {
        return '—'
      }
      return `${val}${unit === '%' ? '' : ' '}${unit}`
    },

    formatMoney(val) {
      return parseFloat(val || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    formatNumber(val) {
      return parseInt(val || 0).toLocaleString('zh-CN')
    },

    getHourLabels() {
      return Array.from({ length: 24 }, (_, i) => i + ':00')
    },

    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        this.fetchRealtime()
      }, 30000)
    },

    syncGlobalRangeParams() {
      if (this.dateArr) {
        this.listQuery.start_at =
          moment(this.dateArr[0]).format('YYYY-MM-DD') + ' 00:00:00'
        this.listQuery.end_at =
          moment(this.dateArr[1]).format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },

    handleGlobalRangeChange() {
      this.syncGlobalRangeParams()
      this.fetchAllData()
    },

    handleFilter() {
      this.syncGlobalRangeParams()
      this.fetchAllData()
    },

    handleReset() {
      this.dateArr = null
      this.listQuery = {
        app_client_id: 0,
        target_type: '',
        compare_type: 'hb',
        start_at: '',
        end_at: '',
      }
      this.fetchAllData()
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-summary {
  .mb18 {
    margin-bottom: 18px;
  }

  .hero {
    background: #f6fbf7;
    border-radius: 8px;
    padding: 20px 28px;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 0;
  }
  .hero-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 120px;
  }
  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #67c23a;
    color: #fff;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.6;
    &::before {
      content: '';
      width: 6px;
      height: 6px;
      background: #fff;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
  .hero-time {
    font-size: 12px;
    color: #909399;
    margin-top: 6px;
    letter-spacing: 0.3px;
  }
  .hero-block {
    display: flex;
    flex-direction: column;
    padding: 0 36px;
  }
  .hero-label {
    font-size: 13px;
    color: #606266;
    margin-bottom: 4px;
    letter-spacing: 0.2px;
  }
  .hero-rate {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.2;
    &.up {
      color: #f56c6c;
    }
    &.down {
      color: #67c23a;
    }
  }
  .hero-big {
    font-size: 28px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;
  }
  .hero-sub {
    font-size: 12px;
    color: #909399;
    margin-top: 3px;
    line-height: 1.4;
  }
  .hero-sep {
    width: 1px;
    height: 56px;
    background: #dcece0;
    flex-shrink: 0;
  }

  .kpi-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
  }
  .kpi-card {
    height: -webkit-fill-available;
    margin-bottom: 16px;
    .kpi-label {
      font-size: 13px;
      color: #909399;
      margin-bottom: 10px;
    }
    .kpi-val {
      font-size: 22px;
      font-weight: 700;
      line-height: 1.1;
      &.blue {
        color: #409eff;
      }
      &.dark {
        color: #303133;
      }
      &.orange {
        color: #e6a23c;
      }
      &.red {
        color: #f56c6c;
      }
      &.green {
        color: #67c23a;
      }
      &.purple {
        color: #9b59b6;
      }
    }
    .kpi-sub {
      font-size: 11px;
      color: #b4b8bd;
      margin-top: 6px;
    }
  }

  .bottom-strip {
    background: #fff;
    border-radius: 6px;
    padding: 20px 24px;
    display: flex;
  }
  .bk-item {
    flex: 1;
    text-align: center;
    position: relative;
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 10%;
      height: 80%;
      width: 1px;
      background: #ebeef5;
    }
  }
  .bk-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
  }
  .bk-val {
    font-size: 22px;
    font-weight: 700;
  }
  .bk-sub {
    font-size: 11px;
    color: #b4b8bd;
    margin-top: 4px;
  }

  .sec-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    .sub {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      margin-left: 6px;
    }
  }
  .chart-t {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    .sub {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      margin-left: 6px;
    }
  }
  .chart-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .filter-hint {
    margin-left: 8px;
    color: #909399;
    font-size: 12px;
  }

  .mobile-chart-title {
    display: none;
  }

  .equal-chart-row {
    align-items: stretch;
  }

  .equal-chart-col {
    display: flex;
  }

  .equal-chart-card {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
  }

  .equal-chart-card ::v-deep .el-card__body {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
  }

  .equal-chart-card .chart-hd {
    flex-wrap: wrap;
  }

  .equal-chart-card .echart {
    flex: 1 1 auto;
    min-height: 240px;
    width: 100%;
  }

  .chart-controls {
    display: flex;
    align-items: center;
  }

  .chart-controls .el-radio-group + .el-radio-group {
    margin-left: 6px;
  }

  @media (max-width: 768px) {
    .filter-hint {
      display: block;
      margin: 4px 0 0;
    }

    .desktop-chart-title {
      display: none;
    }

    .mobile-chart-title {
      display: inline;
    }

    .filter-container ::v-deep .el-form-item {
      display: block;
      margin-right: 0;
    }

    .filter-container ::v-deep .el-date-editor,
    .filter-container ::v-deep .el-select {
      width: 100% !important;
      max-width: 100%;
    }

    .hero {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 12px;
    }

    .hero-left {
      flex: 0 0 100%;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      min-width: 0;
      padding-bottom: 8px;
      border-bottom: 1px solid #eef1f6;
      margin-bottom: 4px;
    }

    .hero-time {
      margin-top: 0;
      margin-left: 10px;
    }

    .hero-sep {
      display: none;
    }

    .hero-block {
      display: flex;
      flex: 0 0 100%;
      flex-direction: column;
      align-items: flex-start;
      box-sizing: border-box;
      width: 100%;
      margin-top: 8px;
      padding: 10px 14px;
      overflow: hidden;
      border: 1px solid #eef1f6;
      border-radius: 10px;
      background: #f8fafc;
    }

    .hero-block .hero-label,
    .hero-block .hero-big,
    .hero-block .hero-rate,
    .hero-block .hero-sub {
      flex: 0 0 auto;
      max-width: 100%;
      margin-right: 0;
    }

    .hero-block .hero-sub {
      margin-top: 4px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .hero-badge {
      gap: 0;
    }

    .hero-badge::before {
      margin-right: 5px;
    }

    .kpi-row > ::v-deep .el-col-4 {
      width: 33.3333%;
    }

    .kpi-card ::v-deep .el-card__body {
      padding: 14px 10px;
    }

    .kpi-card .kpi-val {
      font-size: 19px;
      word-break: break-word;
    }

    .bottom-strip {
      display: flex;
      flex-wrap: wrap;
      padding: 8px 4px;
    }

    .bottom-strip .bk-item {
      flex: 1 1 50%;
      box-sizing: border-box;
      min-width: 0;
      padding: 10px 8px;
      border: 1px solid #f0f2f5;
      border-radius: 10px;
      background: #fafbfc;
    }

    .bottom-strip .bk-item::after {
      display: none;
    }

    .bk-val {
      font-size: 20px;
      word-break: break-word;
    }

    .chart-hd {
      flex-wrap: wrap;
      gap: 6px !important;
    }

    .chart-t .sub {
      display: none !important;
    }

    .chart-hd > * {
      margin-bottom: 6px;
    }

    .chart-hd > .chart-controls {
      width: 100%;
      margin-top: 4px;
    }

    .chart-hd > div:last-child:not(.el-radio-group) {
      display: flex;
      flex-wrap: wrap;
      gap: 4px !important;
      width: 100%;
      margin-top: 4px;
    }

    .chart-hd > div:last-child > .el-radio-group + .el-radio-group {
      margin-left: 6px;
    }

    .chart-hd .el-radio-group {
      display: flex !important;
      flex-wrap: nowrap !important;
      gap: 0 !important;
      max-width: 100%;
      overflow-x: auto;
      padding-bottom: 2px;
      -webkit-overflow-scrolling: touch;
    }

    .chart-hd .el-radio-group::-webkit-scrollbar {
      height: 0;
    }

    .chart-hd ::v-deep .el-radio-button {
      margin-right: 0 !important;
      margin-left: -1px !important;
    }

    .chart-hd ::v-deep .el-radio-button:first-child {
      margin-left: 0 !important;
    }

    .chart-hd ::v-deep .el-radio-button__inner {
      height: 30px !important;
      padding: 0 10px !important;
      font-size: 12px !important;
      line-height: 28px !important;
      border-radius: 0 !important;
    }

    .chart-controls--hourly {
      flex-wrap: wrap;
    }

    .chart-controls--hourly .el-radio-group {
      margin-bottom: 4px;
    }

    .chart-card {
      margin-bottom: 12px;
    }

    .equal-chart-row {
      flex-wrap: wrap;
    }

    .equal-chart-col,
    .equal-chart-card {
      width: 100%;
    }

    ::v-deep .el-col-8,
    ::v-deep .el-col-10,
    ::v-deep .el-col-14 {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    .kpi-row > ::v-deep .el-col-4 {
      width: 50%;
    }

    .kpi-card ::v-deep .el-card__body {
      padding: 12px 8px;
    }
  }

  .filter-container {
    background: #fff;
    border-radius: 6px;
    // padding: 16px 20px;
  }

  .rate-green {
    color: #67c23a !important;
  }
  .rate-orange {
    color: #e6a23c !important;
  }
  .rate-red {
    color: #f56c6c !important;
  }
}
</style>
